<template>
  <div>
    <b-table
      v-if="receiptData.length"
      ref="refReceiptCNTable"
      class="position-relative event_list shadow-table"
      :items="receiptData"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      no-sort-reset
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
    >
      <!-- <template #empty="">
        <b-row>
          <b-col>
            <div class="empty_block">
              <h4>No receipt / credit notes found.</h4>
            </div>
          </b-col>
        </b-row>
      </template> -->
      <template #cell(trxNo)="data">
        <div
          v-if="data.item.type && data.item.type.toLowerCase().includes('receipt')"
          class="text-nowrap"
        >
          <b-button
            v-if="canViewThisAction('show', 'Receipt')"
            variant="link"
            class="p-0 weight-600"
            :to="{ name: 'customers-receipts-show', params: { id: data.item.trxID } }"
          >
            {{ data.item.trxNo }}
          </b-button>
          <span
            v-else
            class=""
          >{{ data.item.trxNo }}</span>
        </div>
        <div
          v-else
          class="text-nowrap"
        >
          <span class="weight-600">{{ data.item.trxNo }}</span>
        </div>
      </template>
      <template #cell(amount)="data">
        <div class="text-nowrap">
          <span class="">${{ numberFormat(data.item.amount) }}</span>
        </div>
      </template>
      <template #cell(paymentType)="data">
        <div class="text-nowrap">
          <span class="">{{ (data.item.transactions && data.item.transactions.length) ?data.item.transactions[0].paymentType : '' }}</span>
        </div>
      </template>
      <template #cell(cardNo)="data">
        <div class="text-nowrap">
          <span class="">{{ (data.item.transactions && data.item.transactions.length) ?data.item.transactions[0].cardNumber : '' }}</span>
        </div>
      </template>
      <template #cell(bank)="data">
        <div class="text-nowrap">
          <span class="">{{ (data.item.transactions && data.item.transactions.length) ?data.item.transactions[0].bankDescription : '' }}</span>
        </div>
      </template>
      <template #cell(createdAt)="data">
        <div class="text-nowrap">
          <span class="">{{ getCreatedBy(data.item) }}</span>
          <br>
          <span class="">{{ getCreatedAt(data.item) }}</span>
        </div>
      </template>
      <template #cell(updatedAt)="data">
        <div class="text-nowrap">
          <span class="">{{ getUpdatedBy(data.item) }}</span>
          <br>
          <span class="">{{ getUpdatedAt(data.item) }}</span>
        </div>
      </template>
      <template #bottom-row="">
        <td
          class="bottom-row"
          colspan="10"
        >
          <span class="weight-500 fs-18">Total Credit {{ getTotal() }}</span>
        </td>
      </template>
    </b-table>
    <div
      v-else
      class="empty_block"
    >
      <h4>No receipt / credit notes found.</h4>
    </div>
  </div>
</template>

<script>
import {
  BTable, VBTooltip, BButton,
} from 'bootstrap-vue'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BTable,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    receiptData: {
      type: [Array, null],
      default: () => [],
    },
    ledgerSummary: {
      type: [Object, null],
      default: () => {},
    },
  },
  data() {
    return {
      user: store.state.auth.userData,
      render: false,
      sortBy: 'createdAt',
      sortDesc: false,
      isSortDirDesc: true,
      tableItems: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 10,
      tableColumns: [
        {
          key: 'trxNo',
          label: 'TRX No.',
          sortable: true,
        },
        {
          key: 'type',
          label: 'Type',
          sortable: true,
        },
        {
          key: 'item',
          label: 'Item',
          sortable: true,
        },
        {
          key: 'amount',
          label: 'amount',
          sortable: true,
        },
        {
          key: 'paymentType',
          label: 'Payment type',
          sortable: true,
        },
        {
          key: 'cardNo',
          label: 'Cheque/card no',
          sortable: true,
        },
        {
          key: 'bank',
          label: 'bank in',
          sortable: true,
        },
        {
          key: 'remarks',
          label: 'Remarks',
          sortable: true,
        },
        {
          key: 'createdAt',
          label: 'Created by',
          sortable: true,
        },
        {
          key: 'updatedAt',
          label: 'Last Updated by',
          sortable: true,
        },
      ],
    }
  },

  methods: {
    canViewThisAction,
    getCreatedBy(item) {
      if (item.createdByCustomer) {
        return item.createdByCustomer.name
      }
      if (item.createdByNvs) {
        return item.createdByNvs.name
      }
      if (item.createdBy) {
        return item.createdBy
      }

      return ''
    },
    getCreatedAt(item) {
      if (item.createdAtNvs) {
        return this.dateFormatWithTime(item.createdAtNvs)
      }
      if (item.createdAt) {
        return this.dateFormatWithFormatNTZ(item.createdAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    getUpdatedBy(item) {
      if (item.updatedByNvs) {
        return item.updatedByNvs.name
      }
      if (item.updatedBy) {
        return item.updatedBy
      }

      return ''
    },
    getUpdatedAt(item) {
      if (item.updatedAtNvs) {
        return this.dateFormatWithTime(item.updatedAtNvs)
      }
      if (item.updatedAt) {
        return this.dateFormatWithFormatNTZ(item.updatedAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    resolveFileStatusVariant(status) {
      if (status === 'OPEN') return 'warning'
      if (status === 'BOOK') return 'info'
      return 'success'
    },
    splitNewLine(text, index) {
      if (text) {
        const separateLines = text.split(/\r?\n|\r|\n/g)
        if (separateLines[index]) {
          return separateLines[index]
        }
      }

      return ''
    },
    getTotal() {
      const total = this.receiptData.reduce((n, { amount }) => n + Number(amount), 0)
      if (total) {
        return `$${this.numberFormat(total)}`
      }

      return '-'
    },
  },
}
</script>
